import React, { Dispatch } from 'react';
import { useLocation } from 'react-router-dom';
import useApi, { api } from '../../hooks/api.hooks';
import { Action, setAuthenticated, setEID, setUser } from './actions';
import { AuthenticationState } from './reducer';

export const useAuthData = (state: AuthenticationState, dispatch: Dispatch<Action>) => {
  const { data, revalidate } = useApi('/isloggedin', {
    baseURL: '/auth',
  });
  const { pathname } = useLocation();

  React.useEffect(() => {
    if (!data) return;

    dispatch(setAuthenticated(data));
  }, [data]);

  React.useEffect(() => {
    if (!data) return;
    revalidate();
  }, [pathname]);

  return data;
};

export const useUserData = (
  { isAuthenticated }: AuthenticationState,
  dispatch: Dispatch<Action>,
) => {
  const { pathname } = useLocation();
  const { data, revalidate } = useApi(isAuthenticated ? '/me' : '');

  const refreshUser = async () => {
    const { data: updatedUser } = await api.get('/me');
    dispatch(setUser(updatedUser));
  };

  React.useEffect(() => {
    if (!data) return;

    dispatch(setUser(data));
  }, [data]);

  React.useEffect(() => {
    if (!data) return;
    revalidate();
  }, [pathname]);

  return {
    data,
    refreshUser,
  };
};

export const useEIDData = (state: AuthenticationState, dispatch: Dispatch<Action>) => {
  const { data } = useApi('/access-keys/eid');

  React.useEffect(() => {
    if (!data) return;

    dispatch(setEID(data));
  }, [data]);

  return data;
};
